module.exports = __webpack_public_path__ + "assets/img/lietuvos-zemelapis-sviesos-intensyvumas.20fb7a83.webp";